import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  Image,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import React, { useState } from "react";
import Colours from "../../utils/Colours";
import { TouchableOpacity } from "react-native";
import MoneyIcon from "../../icons/MoneyIcon";
import ViewMoreIcon from "../../icons/ViewMoreIcon";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import { useEffect } from "react";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TableInvitesPage = ({
  tableInvites,
  setTableInviteVisible,
  setTableInvites,
  tableInviteVisible,
  getNotificationData,
}) => {
  const [showTableCreditCategories, setShowTableCreditCategories] = useState(false);
  const [a_InviteTableID, setA_InviteTableID] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [isLoadingN, setIsLoadingN] = useState(false);
  const [tableCaption, setTableCaption] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const newDataRefresh = async () => {
      //console.log('triggered');
      setIsLoadingN(true);
      await getNotificationData();
      setIsLoadingN(false);
    };

    newDataRefresh();
  }, [refreshTrigger]);

  // useEffect(() => {

  //     const newDataRefresh = async () => {
  //         setIsLoadingN(true);
  //         try {
  //             const response = await getTableInvites()
  //             //console.log('responsecc', response);
  //             if (response.length === 0) {
  //                 setTableInvites([]);
  //             } else {
  //                 setTableInvites(response);
  //             }
  //         } catch (error) {
  //             //console.error('Error refreshing data:', error);
  //         }
  //         setIsLoadingN(false);
  //     }

  //     newDataRefresh()
  // }, [refreshTrigger])

  useEffect(() => {
    //console.log('tableInvitesxx', tableInvites)
  }, [tableInvites]);

  const refreshData = () => {
    setRefreshTrigger(!refreshTrigger);
    //console.log('triggered')
  };

  const handleOpenTableCategories = (id, caption) => {
    setShowTableCreditCategories(true);
    setTableCaption(caption);
    setA_InviteTableID(id);
  };

  if (isLoadingN) {
    return (
      <View style={{ flex: 1, alignItems: "center" }}>
        <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <View>
      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        <View>
          {tableInviteVisible && <></>}
          <View style={styles.invitesTablesContainer}>
            <View style={styles.headerStyle}>
              <Text
                style={{
                  marginTop: dynamicSpacing(10),
                  marginBottom: dynamicSpacing(10),
                  fontSize: dynamicFontSize(16),
                  color: Colours.PRIMARY,
                  fontFamily: "Sen-Bold",
                }}
              >
                Invited to join
              </Text>
              {/* <Text style={{ paddingLeft: 1, paddingBottom: 0, color: '#5bb450', fontSize: 16, fontFamily: 'Sen-Bold' }}>N125,000</Text> */}
            </View>
            <FlatList
              keyExtractor={(item) => item._id}
              data={tableInvites}
              scrollEnabled={false}
              renderItem={({ item: tableData }) => (
                <View>
                  <TouchableOpacity
                    style={styles.oneTableContainer}
                    //   onPress={() => handleShowTableToUse(tableData._id)}>

                    onPress={() => {}}
                  >
                    <View style={styles.tableNameAmountContainer}>
                      <Text
                        style={{
                          marginBottom: dynamicSpacing(10),
                          color: Colours.DARKGRAY,
                          fontSize: dynamicFontSize(15),
                          fontFamily: "Sen-Bold",
                        }}
                      >
                        {tableData?.relatedTable?.tableCaption}
                      </Text>
                      <View style={styles.tableAmountContainer}>
                        <MoneyIcon color={Colours.PRIMARY_LIGHT} height={30} width={30} />
                        <Text
                          style={{
                            color: Colours.DARKLIGHTGRAY,
                            fontSize: dynamicFontSize(13),
                            fontFamily: "Sen-Regular",
                          }}
                        >
                          Money on the table:
                        </Text>
                        <Text
                          style={{
                            color: Colours.PRIMARY,
                            fontSize: dynamicFontSize(16),
                            fontFamily: "Sen-Bold",
                          }}
                        >
                          {tableData?.relatedTable?.totalContributionsAmount.toLocaleString()}
                        </Text>
                      </View>

                      {/* {tableData ? (
                                                <View style={{ flexDirection: 'column' }}>
                                                    {tableData?.pull && (
                                                        <View style={{ flexDirection: 'column' }}>
                                                            <View key={tableData.pull._id} style={styles.tableAmountContainer}>
                                                                <Text style={{ marginBottom: 5, color: Colours.PRIMARY_LIGHT, fontSize: 13, fontFamily: 'Sen-Regular', width: 150 }}>
                                                                    {tableData.pull.pullCaption}
                                                                </Text>
                                                            </View>
                                                        </View>
                                                    )}
                                                </View>
                                            ) : null} */}
                      <View style={styles.tableJoined}>
                        {/* <PullsIcon color={Colours.PRIMARY_LIGHT} /> */}
                        <TouchableOpacity
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 5,
                            alignItems: "center",
                          }}
                        >
                          {tableData?.sender?.profilePicture ? (
                            <Image
                              source={{ uri: tableData?.sender?.profilePicture }}
                              style={styles.userImage}
                            />
                          ) : (
                            <Image
                              source={require("../../../assets/profile_image_holder.jpg")}
                              style={styles.userImage}
                            />
                          )}
                          <Text
                            style={{
                              color: Colours.DARKLIGHTGRAY,
                              fontSize: dynamicFontSize(13),
                              fontFamily: "Sen-Regular",
                            }}
                          >
                            {tableData?.sender?.username}{" "}
                          </Text>
                        </TouchableOpacity>
                        {/*Removing ability to join  table invites due to the challenges of funding huge transfers*/}
                        {/* 
                                                <TouchableOpacity style={styles.joinTableButton}
                                                    onPress={() => { handleOpenTableCategories(tableData?.relatedTable._id, tableData?.tableCaption) }}>

                                                    <Text style={{ color: 'white', fontSize: dynamicFontSize(12), fontFamily: 'Sen-Bold' }}>Join this Table</Text>
                                                </TouchableOpacity>
                                                 */}
                      </View>
                    </View>
                  </TouchableOpacity>

                  <View
                    style={{
                      height: 1,
                      backgroundColor: Colours.LIGHTGRAY,
                      marginVertical: dynamicSpacing(5),
                      width: dynamicSize(330),
                      marginBottom: dynamicSpacing(10),
                    }}
                  />
                </View>
              )}
              // refreshing={refreshing}
              // onRefresh={handleRefresh}
              inverted={true}
            />
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
  invitesTablesContainer: {
    display: "flex",
    margin: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  headerStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: dynamicSpacing(5),
    alignItems: "center",
    gap: 1,
  },
  oneTableContainer: {
    display: "flex",
    backgroundColor: "white",
    borderRadius: dynamicSize(10),
    paddingTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
  },
  tableNameAmountContainer: {
    display: "flex",
  },
  tableAmountContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
    marginBottom: dynamicSpacing(10),
  },
  joinTableButton: {
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(5),
    padding: dynamicSpacing(5),
    backgroundColor: Colours.PRIMARY,
    height: dynamicSize(25),
    width: dynamicSize(100),
  },
  tableJoined: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: dynamicSpacing(10),
  },
  userImage: {
    width: dynamicSize(35),
    height: dynamicSize(35),
    borderRadius: dynamicSize(99),
  },
});

export default TableInvitesPage;
